import styled from 'styled-components';

export const FaqFormContainer = styled.div`
      .form-container {
            background: white;
            max-width: 680px;
            width: 100%;
            padding: 30px 40px;
            border-radius: 15px;
            box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
            transition: box-shadow 0.3s ease;
      }
      .form-container:hover {
            box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
      }
      h2 {
            font-weight: 600;
            text-align: center;
            color: #343a40;
            margin-bottom: 25px;
            letter-spacing: 1.1px;
      }
      label {
            font-weight: 600;
            color: #495057;
            display: block;
            margin-bottom: 6px;
            margin-top: 20px;
            font-size: 14.5px;
            letter-spacing: 0.5px;
      }

      .optional {
            font-weight: 400;
            font-style: italic;
            font-size: 13px;
            color: #868e96;
            margin-left: 6px;
      }
      fieldset {
            margin-top: 25px;
            border-radius: 10px;
            border: 1.5px solid #ced4da;
            padding: 18px 20px 15px 20px;
            background-color: #f8f9fa;
            box-sizing: border-box;

            legend {
                  font-weight: 700;
                  font-size: 15px;
                  padding: 0 10px;
                  color: #495057;
                  float: none;
                  width: fit-content;
                  margin: 0;
            }

            .radio-group {
                  margin: 0;

                  label {
                        margin: 0;
                  }
            }
      }
      .radio-group,
      .checkbox-group {
            margin-top: 10px;
            display: flex;
            flex-wrap: wrap;
            gap: 15px;
      }
      .radio-group label,
      .checkbox-group label {
            font-weight: 500;
            cursor: pointer;
            font-size: 14px;
            user-select: none;
            color: #495057;
            background: white;
            padding: 8px 14px;
            border-radius: 8px;
            border: 1.8px solid #ced4da;
            transition: all 0.3s ease;
            display: flex;
            align-items: center;
            gap: 6px;
      }
      .radio-group input[type='radio'],
      .checkbox-group input[type='checkbox'] {
            accent-color: #3366ff;
            cursor: pointer;
            width: 18px;
            height: 18px;
            margin: 0;
      }
      .radio-group label:hover,
      .checkbox-group label:hover {
            background: #e6f0ff;
            border-color: #3366ff;
            color: #2247e0;
      }
      .radio-group input[type='radio']:checked + span,
      .checkbox-group input[type='checkbox']:checked + span {
            font-weight: 600;
            color: #2247e0;
      }
`;
